import { useAtomValue } from "jotai";
import { clientConfigAtom } from "atoms/clientConfig";
import { sessionConfigAtom } from "atoms/sessionConfig";

export const useConfig = () => {
  const config = useAtomValue(clientConfigAtom);
  const sessionConfig = useAtomValue(sessionConfigAtom);

  if(!sessionConfig) {
    return config;
  }

  const hasSessionConfigTranslationDicts = sessionConfig?.translationDicts && sessionConfig.translationDicts.length > 0
  const hasSessionConfigContactButton = sessionConfig?.contactButton

  return {
    ...config,
    translationDicts:  hasSessionConfigTranslationDicts ? sessionConfig?.translationDicts : config.translationDicts,
    contactButton: hasSessionConfigContactButton ? sessionConfig.contactButton : config.contactButton,
  }
};
